import { format, parseISO } from 'date-fns'

import { Operator } from '@img-arena/consoles-api-streaming'
import { DataCardDetailsEntry } from '@/components/card'

export const getOperatorHeaderItems = (
  operator: Operator | null | undefined
): DataCardDetailsEntry[] => {
  return [
    {
      key: 'ID',
      value: operator?.id || '-',
      copyable: true
    },
    {
      key: 'Contact Name',
      value: operator?.mainContactName || '-'
    },
    {
      key: 'Contact Email',
      value: operator?.mainContactEmail || '-'
    },
    {
      key: 'Contact Number',
      value: operator?.mainContactTel || '-'
    },
    {
      key: 'Created At',
      value: operator?.createdAt ? format(parseISO(operator.createdAt), 'PPpp') : '-'
    }
  ]
}
